import { render } from "./PortalView.vue?vue&type=template&id=6836521e"
import script from "./PortalView.vue?vue&type=script&lang=js"
export * from "./PortalView.vue?vue&type=script&lang=js"

import "./PortalView.vue?vue&type=style&index=0&id=6836521e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__